import { Box, Button } from '@factorialco/deprecated-design-system'
import { AtsHiringStageNamesEnum } from 'generated/resources/datatable.graphql'
import { AtsNewStageButtonFragment } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateHiringStage } from 'modules/ats/hooks/hiringStages/useCreateHiringStage'
import { HiringStage } from 'modules/ats/hooks/hiringStages/useHiringStages'

interface Props {
  position: number
  stages: HiringStage[]
  hiringStageOptions: AtsNewStageButtonFragment[]
}

export const NewStageButton = ({ stages, position, hiringStageOptions }: Props) => {
  const { create } = useCreateHiringStage()
  const { company } = useCurrentSession()

  const stagesNotAllowed = stages
    .filter(
      (stage) =>
        stage.name === 'new' ||
        stage.name === 'hired' ||
        stage.name === 'offer' ||
        stage.position === position ||
        stage.position === position - 1
    )
    .map((stage) => stage.name)

  const availableStages =
    hiringStageOptions.filter(
      (stage_option) =>
        !stagesNotAllowed.includes(stage_option.name) &&
        stage_option.name !== 'new' &&
        stage_option.name !== 'hired'
    ) || []

  const createNewStage = async (stageName: AtsHiringStageNamesEnum) => {
    const result = await create({
      companyId: company.id,
      position: position,
      name: stageName,
    })
    const handled = handleResult(result, () => {})

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }
  }

  return (
    <Box flexDirection="row" justifyContent="center" alignItems="center" gap="s16">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative
            type="secondary"
            aria-label={i18n.t('ats.hiring_pipelines.settings.sidepanel.new_stage')}
            iconName="add"
          />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          {availableStages.map((stage) => (
            <PopoverMenu.TouchableOption
              title={stage.label}
              onClick={() => createNewStage(stage.name)}
              key={`option-${stage.name}`}
            />
          ))}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
